import React from 'react'
import PropTypes from 'prop-types'

function ProofAndPenalties ({ penAndFine, drawType }) {
    return (
        <div className='flex flex-col gap-5'>
            <section className='font-semibold penalties-section flex flex-col gap-3'>
                <div className='font-semibold text-primary text-subHeading-2'>Cost of non-compliance</div>
                <div className='font-semibold flex text-danger  text-subHeading-2'>Penalties and Fines : <div style={{ color: penAndFine?.[0] === 'All good' ? 'hsl(var(--Low))' : undefined }}>{penAndFine?.[0]}</div></div>
                <div className='font-semibold flex text-danger  text-subHeading-2'>Damage to Reputation : <div style={{ color: penAndFine?.[0] === 'All good' ? 'hsl(var(--Low))' : '' }} >{penAndFine?.[1]}</div></div>
            </section>
        </div>
    )
}
ProofAndPenalties.propTypes = {
    penAndFine: PropTypes.any,
    drawType: PropTypes.any
}
export default ProofAndPenalties
